import * as React from 'react';

type Props = {
  errors: string[];
};

export function RootErrors({ errors }: Props) {
  if (errors.length === 0) return null;
  return (
    <div className="text-destructive flex flex-col items-end gap-1 text-sm">
      {errors.map((msg, i) => (
        <div key={i}>{msg}</div>
      ))}
    </div>
  );
}
